import { clientApi as api } from '@common/api'
import type { IRejectedPayloadType } from '@redux/slices/applicationList/applicationList.types'
import type { AxiosError } from 'axios'


export interface IApiError {
  detail?: IRejectedPayloadType['detail'],
  status: number | boolean,
}

const submitHandler: (
  data: { fields: Record<string, any>, appId: string, reviewId: string },
  params: { deleteMode: boolean },
  form: {
    setError: (statusCode: IApiError) => void,
    clearErrors: () => void,
    onSuccess: () => void,
  },
) => Promise<void> = async (data, params, form) => {
  const { fields, appId, reviewId } = data
  const { deleteMode } = params

  const req: IRequestAppReviewCreate = {
    ...fields as IRequestAppReviewCreate,
  }

  const url = `/api/app/${appId}/reviews/${reviewId}/developer-response`

  const method = deleteMode ? 'delete' : 'put'

  try {
    await api[method]<unknown>(url, req, {
      params: {
        id: appId,
      },
    })
    form.clearErrors()
    form.onSuccess()
  } catch (e) {
    const err = e as AxiosError
    const data = err.response?.data as IRejectedPayloadType
    const apiError = {
      detail: data?.detail,
      status: err.response?.status || true,
    }
    form.setError(apiError)
  }
}

export default submitHandler
